import React from "react";
import Button from "../../../components/buttons/Button";
import { useNavigate, useParams } from "react-router-dom";
import { GetService } from "../../../hooks/useServiceData";

export const ServiceOverviewView = () => {
  const { id: serviceId } = useParams();
  const navigate = useNavigate();
  const { data } = GetService(serviceId);

  const clickEdit = (id) => {
    navigate(`/registry/service/edit/${id}`);
  };

  return (
    <>
      <div className="container" style={{ width: "100%" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h2>{data?.data.name}</h2>
          <div>
            <Button onClick={() => clickEdit(serviceId)}>Redigera</Button>
          </div>
        </div>
        <table className="vertical-table">
          <tbody>
            <tr>
              <th>ID</th>
              <td>{data?.data.id}</td>
            </tr>
            <tr>
              <th>Namn</th>
              <td>{data?.data.name}</td>
            </tr>
            <tr>
              <th>Ägare ID</th>
              <td>{data?.data.owner_id}</td>
            </tr>
            <tr>
              <th>Kostnad</th>
              <td>{data?.data.cost}</td>
            </tr>
            <tr>
              <th>Aktiv</th>
              <td>{data?.data.isActive ? "Ja" : "Nej"}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};
